import type { InjectionKey } from 'vue'

import type {
  BlockType,
  BlockTypeProps,
} from '@backmarket/http-api/src/api-specs-content/models/block'
import type { Device } from '@backmarket/http-api/src/api-specs-content/models/device'

import type { ContentBlockProps } from '../../models/content-block'

import type { HydrationMode } from './BlockRenderer.constants'

export type BlockRendererProps = {
  // List of device for which the block is hidden.
  hiddenDevices: Device[]
  // Apply a margin bottom to the block.
  withBottomMargin?: boolean
  // Component name, needs to be found in the index.
  type: BlockType
  // Component properties used to instantiate the component.
  props: BlockTypeProps

  hydrationMode?: HydrationMode
} & Required<Pick<ContentBlockProps, 'blockPosition' | 'id'>> &
  ContentBlockProps

export type PageParams = {
  pageType: string
  pageName: string
  pageCategory?: string
}

export const BLOCK_RENDERER_PAGE_PARAMS_INJECTION_KEY = Symbol(
  'bm.nuxt-layer-cms.block-renderer-page-params',
) as InjectionKey<PageParams>
